export const BRAINTRUST_PROJECT_NAME = "ticket-copilot";

export const COPILOT_ID = "ticketcopilot";
